<template>
    <div class="animated fadeIn">
        <DynamicForm
                v-model="dataId"
                ref="dynamicForm"
                getRoot="/binder-pdf-stamp"
                saveRoot="/binder-pdf-stamp"
                @onTrashClick="onTrashClick"
                :formStructure="dataFormStructures.binderPDFStamp">
        </DynamicForm>
        <ModalTrash
                ref="trash"
                root="/binder-pdf-stamp"
                @onTrashSuccess="onTrashSuccess"
                :caption="Core.Definition.getDefinition('Suppression de l\'étampe')"
                :message="Core.Definition.getDefinition('Êtes-vous sûr de vouloir supprimer cette étampe?')"></ModalTrash>
    </div>
</template>

<script>
    import DynamicForm from '../../components/DynamicForm'
    import ModalTrash from '../../components/ModalTrash'
    export default {
        name: 'BinderPDFStamp',
        components: {
            DynamicForm,
            ModalTrash
        },
        props: {
            value: {
                type: Number | String,
                default: ''
            }
        },
        mounted() {
            this.dataId = this.value
        },
        data: function () {
            return {
                dataCapsGroups: [],
                Core: window.Core,
                dataId: '',
                dataFormStructures: {
                    binderPDFStamp: {
                        rows: [
                            {
                                cols: [
                                    {
                                        cards: [
                                            {
                                                caption: Core.Definition.getDefinition('Étampe'),
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'title'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'image'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        fields: [
                            {
                                id: 'title',
                                type: 'text',
                                label: Core.Definition.getDefinition('Titre'),
                                value: '',
                                required: true
                            },
                            {
                                id: 'image',
                                type: 'image',
                                label: Core.Definition.getDefinition('Image'),
                                value: []
                            }
                        ]
                    }
                }
            }
        },
        methods: {
            onTrashClick(id) {
                this.$refs.trash.open(id)
            },
            onTrashSuccess() {
            }
        }
    }
</script>

